import { useEffect } from 'react';

const useElementEvent = (
  selector: Element | string | null,
  callback: EventListener,
  event = 'click'
): void => {
  useEffect(() => {
    let element: Element | null = null;

    if (typeof selector === 'string') {
      element = document.querySelector(selector);
    } else {
      element = selector;
    }

    element?.addEventListener(event, callback);

    return () => {
      element?.removeEventListener(event, callback);
    };
  }, [selector, callback, event]);
};

export default useElementEvent;
